import React from "react";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import "../styles/nosotrosPage.css";
import { StaticImage } from "gatsby-plugin-image";
import CTAComponent from "../components/CTAComponent";
import ContactForm from "../components/ContactForm";

const nosotros = () => {
  return (
    <>
      <GatsbySeo
        title="Nosotros"
        description="Omega agencia de viajes, viajes a todos los destinos con lo mejores precios"
        canonical="https://omega-agencia.netlify.app/nosotros/"
        metaTags={[
          {
            property: "og:url",
            content: "https://omega-agencia.netlify.app/nosotros/",
          },
          {
            property: "og:title",
            content: "Nosotros | Omega Agencia de Viajes",
          },
        ]}
      />
      <section className="nosotros-banner">
        <div className="nosotros-banner-align">
          <div className="nosotros-title">
            <h1>Nosotros</h1>
          </div>
          <div>
            <StaticImage
              src="../images/omega-nosotros.png"
              className="omega-nosotros-img"
              alt="omega logo"
              quality={100}
              loading="lazy"
              placeholder="tracedSVG"
            />
          </div>
        </div>
      </section>
      <article>
        <div className="nosotros-title-desc">
          <h2>Historia</h2>
        </div>
        <div className="nosotros-desc-align">
          <div className="nosotros-desc">
            <p>
              Desde 1968 somos responsabilidad, confianza y compromiso,
              innovando en los servicios a nuestros usuarios definiéndonos como
              la organización venezolana líder en viajes corporativos, turismo
              personalizado y eventos. Durante nuestros años de trayectoria,
              hemos desarrollado la capacidad de adaptar nuestra infraestructura
              a los requerimientos de nuestros clientes, lo que nos permite
              ofrecer un servicio integral en materia de viajes y turismo, con
              la más alta tecnología, destacándonos por brindar servicio
              personalizado.
            </p>
            <p>
              Somos un equipo integrado de más de 60 profesionales, altamente
              capacitados, dispuestos a brindarle soluciones en las áreas
              corporativas, eventos y turismo, porque su tranquilidad es nuestra
              satisfacción.
            </p>
            <p>
              Desde junio del año 2011 formamos parte de la red global FCm
              Travel Solutions, como resultado de la constante búsqueda por
              implementar las mejores herramientas que permitan a nuestros
              clientes, disfrutar, con plenitud, de todos nuestros productos
              para su negocio mediante soluciones, permitiendo economizar en sus
              programas de viajes.
            </p>
          </div>
        </div>
      </article>
      <CTAComponent />
      <ContactForm />
    </>
  );
};

export default nosotros;
